import { formatPhone } from '../../../../../../../../common/functions/formatPhone';
import { Broker } from '../../../queries/brokerQueries';
import { CardSectionLabel } from './CardSectionLabel';

/** "Email:" and the broker's email, then "Phone:" and its phone; each only when the broker has one. */
export const BrokerContact = ({ broker }: { broker: Broker }) => {
    return (
        <>
            {broker.email && (
                <div>
                    <CardSectionLabel>Email:</CardSectionLabel>
                    <div>{broker.email}</div>
                </div>
            )}
            {broker.phone && (
                <div>
                    <CardSectionLabel>Phone:</CardSectionLabel>
                    <div>{formatPhone(broker.phone)}</div>
                </div>
            )}
        </>
    );
};
